"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetStayAlignedRelaxedPoseRequestT = exports.ResetStayAlignedRelaxedPoseRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const stay_aligned_relaxed_pose_js_1 = require("../../solarxr-protocol/rpc/stay-aligned-relaxed-pose.js");
class ResetStayAlignedRelaxedPoseRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsResetStayAlignedRelaxedPoseRequest(bb, obj) {
        return (obj || new ResetStayAlignedRelaxedPoseRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsResetStayAlignedRelaxedPoseRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ResetStayAlignedRelaxedPoseRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    pose() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : stay_aligned_relaxed_pose_js_1.StayAlignedRelaxedPose.STANDING;
    }
    static startResetStayAlignedRelaxedPoseRequest(builder) {
        builder.startObject(1);
    }
    static addPose(builder, pose) {
        builder.addFieldInt8(0, pose, stay_aligned_relaxed_pose_js_1.StayAlignedRelaxedPose.STANDING);
    }
    static endResetStayAlignedRelaxedPoseRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createResetStayAlignedRelaxedPoseRequest(builder, pose) {
        ResetStayAlignedRelaxedPoseRequest.startResetStayAlignedRelaxedPoseRequest(builder);
        ResetStayAlignedRelaxedPoseRequest.addPose(builder, pose);
        return ResetStayAlignedRelaxedPoseRequest.endResetStayAlignedRelaxedPoseRequest(builder);
    }
    unpack() {
        return new ResetStayAlignedRelaxedPoseRequestT(this.pose());
    }
    unpackTo(_o) {
        _o.pose = this.pose();
    }
}
exports.ResetStayAlignedRelaxedPoseRequest = ResetStayAlignedRelaxedPoseRequest;
class ResetStayAlignedRelaxedPoseRequestT {
    constructor(pose = stay_aligned_relaxed_pose_js_1.StayAlignedRelaxedPose.STANDING) {
        this.pose = pose;
    }
    pack(builder) {
        return ResetStayAlignedRelaxedPoseRequest.createResetStayAlignedRelaxedPoseRequest(builder, this.pose);
    }
}
exports.ResetStayAlignedRelaxedPoseRequestT = ResetStayAlignedRelaxedPoseRequestT;
